/**
 * Privacy Component
 ****************************************
 *
 * @version 1.0.1
 * @author Anjana Joy
 * @description Privacy for paper flow
 * @createdDate [27/03/2020]
 * ***************************************
 * @lastModifiedDate [27/03/2020]
 * @lastModifiedBy Anjana Joy
 * @lastModifiedReason
 */

import React, { Component } from 'react';
// import { PropTypes } from 'prop-types';
import { Row, Col, Container } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import { WCard, CommonButtons, WStepper } from '../../../common';
import AccGlobalConstants from '../AccountManagementConstants';
import consts from './consts';
import '../AgreementPaperFlow/agreementPaperFlow.css';

class PrivacyComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            next: false,
            back: false,
        };
    }

    // componentDidMount() {

    // }

    handlePdf = () => {
        window.open('https://www.antennahouse.com/XSLsample/pdf/sample-link_1.pdf');
    };

    handleBack = () => {
        this.setState({ back: true });
    };

    handleNext = () => {
        this.setState({ next: true });
    };

    render() {
        const { next, back } = this.state;
        const {
            paperFlowHeading,
            privacyHeading,
            privacyPara1,
            privacyPara2,
            privacyCard1Title,
            privacyCard1Text,
            privacyCard2Title,
            downloadPdfText,
            cardtitlestyle,
        } = consts;

        return (
            <div>
                <Container className="paperFlowPage privacyPage">
                    <Row noGutters>
                        <Col>
                            <h1 className="pageHeading">{paperFlowHeading}</h1>
                            <WStepper pages={AccGlobalConstants.paperFlowPages} currentPage={2} />
                        </Col>
                    </Row>
                    <Row noGutters className="headerRow">
                        <Col>
                            <h2 className="pageSubHeading">{privacyHeading}</h2>
                        </Col>
                    </Row>
                    <Row noGutters className="contentRow">
                        <Col sm={12} className="contentWrapper">
                            <p className="strongPara">{privacyPara1}</p>
                            <p>{privacyPara2}</p>
                        </Col>
                    </Row>
                    <Row noGutters className="cardColWrapper">
                        <WCard
                            className=""
                            cardtitletext={privacyCard1Title}
                            cardtitlestyle={cardtitlestyle}
                            buttontext={downloadPdfText}
                            cardtext={privacyCard1Text}
                            pdflink="https://www.antennahouse.com/XSLsample/pdf/sample-link_1.pdf"
                            downloadtext="true"
                        />
                        <WCard
                            className=""
                            cardtitletext={privacyCard2Title}
                            cardtitlestyle={cardtitlestyle}
                            buttontext={downloadPdfText}
                            cardtext=""
                            pdflink="https://www.antennahouse.com/XSLsample/pdf/sample-link_1.pdf"
                            downloadtext="true"
                        />
                    </Row>
                </Container>
                <CommonButtons backClick={this.handleBack} nextClick={this.handleNext} />
                {next && <Redirect to="/paperApplication" />}
                {back && <Redirect to="/agreement" />}
            </div>
        );
    }
}

export default PrivacyComponent;
